import { downloadCsv, toCsv } from "utils/csv";
import { completionRate, formatDate } from "./summaryConstants";

const HEADERS = [
  "University/College",
  "CRICOS/RTO Code",
  "State",
  "Contact Person",
  "Email",
  "Total Admissions",
  "Completed",
  "In Progress",
  "Withdrawn",
  "Completion %",
  "Clients",
  "Course Offerings",
  "Last Activity",
];

const toRow = (row) => [
  row.name,
  row.code,
  row.state,
  row.contactPerson,
  row.email,
  row.totalAdmissions,
  row.completed,
  row.inProgress,
  row.withdrawn,
  completionRate(row) == null ? "" : completionRate(row),
  row.distinctClients,
  row.courseOfferings,
  row.lastActivityDate ? formatDate(row.lastActivityDate) : "",
];

export const buildSummaryCsv = (rows = [], totals = null) => {
  const lines = [HEADERS, ...rows.map(toRow)];
  if (totals) {
    lines.push([
      "TOTAL",
      "",
      "",
      "",
      "",
      totals.totalAdmissions,
      totals.completed,
      totals.inProgress,
      totals.withdrawn,
      "",
      "",
      "",
      "",
    ]);
    if (totals.unassignedAdmissions) {
      lines.push([
        "Not linked to a college",
        "",
        "",
        "",
        "",
        totals.unassignedAdmissions,
        "",
        "",
        "",
        "",
        "",
        "",
        "",
      ]);
    }
  }
  return toCsv(lines);
};

export const downloadSummaryCsv = (rows, totals, filename = "college-admission-summary.csv") =>
  downloadCsv(buildSummaryCsv(rows, totals), filename);
